import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import fold from './modules/search_fold'
import permission from './modules/permission'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    fold,
    foldMax: {
      namespaced: true,
      state: {
        max: 3,
      },

      mutations: {
        SET_MAX: (state, value) => {
          state.max = value;
        }
      },

      actions: {
        setMax({ commit }, data) {
          commit('SET_MAX', data)
        }
      }
    },
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js